// @flow

import deepEqual from 'deep-equal';

import type { SortingDefinition } from '../types';

const compareSortDescription = (firstSort, secondSort) => {
  const { __typename, ...props } = firstSort;
  const { __typename: _, ...otherProps } = secondSort;

  return deepEqual(props, otherProps);
};

const compareSortDescriptions = (
  firstSortDef: SortingDefinition,
  secondSortDef: SortingDefinition,
) => {
  return (
    firstSortDef &&
    secondSortDef &&
    firstSortDef.length === secondSortDef.length &&
    firstSortDef.every((value, index) =>
      compareSortDescription(value, secondSortDef[index]),
    )
  );
};

export { compareSortDescriptions };
